//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { QInput } from "quasar";

export default {
    name: "QFabricInput",
    components: {
        QInput
    },
    mixins: [QInput],
    props: {
        value: { default: "" },
        isSelect: { default: false },
        stackLabel: { type: String, default: "" },
        label: { type: String, default: "" },
        inset: { type: Boolean, default: true },
        separator: { type: Boolean, default: false },
        rows: { type: String, default: "2" },
        height: { type: Number, default: 90 },
        disabled: { type: Boolean, default: false },
        clearable: { type: Boolean, default: false },
        readonly: { type: Boolean, default: false },
        options: {
            type: Array,
            default() {
                return [{ label: "", value: "" }];
            }
        },
        error: { type: Boolean, default: false },
        errorLabel: { type: String, default: "" },
        multiple: { type: Boolean, default: false },
        after: { type: Array },
        filter: { type: null },
        tabIndex: { type: Number },
        maxlength: { type: Number },
        placeholder: { type: String },
        filterPlaceholder: { type: String },
        displayValue: { type: String }
    },
    data() {
        return {};
    },
    mounted() {
        if (this.$refs.fabricInput) {
            const input = this.$refs.fabricInput.$el.querySelector("input");

            if (input) {
                const scope = this;
                input.setAttribute("readonly", "readonly");
                input.style.backgroundColor = "inherit";
                setTimeout(() => {
                    if (!scope.readonly) {
                        input.removeAttribute("readonly");
                    }
                }, 500);
            }
        }
    },
    methods: {
        setValue(newVal) {
            this.$emit("input", newVal);
        },
        blurEvt(ev) {
            this.$emit("blur", ev);
        },
        focusEvt(ev) {
            this.$emit("focus", ev);
        },
        changeEvt(newVal) {
            this.$emit("change", newVal);
        },
        clickEvent(ev) {
            this.$emit("click", ev);
        }
    }
};
